module.exports = __webpack_public_path__ + "static/media/level5.c1bd54a5.svg";